import { Box, Typography, Paper, Grid, Card, CardContent, Button, TextField, MenuItem, Stack } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { useState } from 'react';
import { api } from '../services/api';

const REPORTS = [
  { key: 'tenants-summary', label: 'Tenants Summary' },
  { key: 'tenant-activity', label: 'Tenant Activity' },
  { key: 'tickets-summary', label: 'Tickets Summary' },
  { key: 'revenue-trend', label: 'Revenue Trend (12 months)' }
];

async function download(path, filename) {
  const r = await api.get(path, { responseType: 'blob' });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement('a'); a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
}

export default function ReportsPage() {
  const now = new Date();
  const [y, setY] = useState(now.getFullYear());
  const [m, setM] = useState(now.getMonth() + 1);
  return (
    <Box>
      <Typography variant="h4" mb={3}>Reports</Typography>
      <Grid container spacing={2}>
        {REPORTS.map(r => (
          <Grid item xs={12} sm={6} md={4} key={r.key}>
            <Card><CardContent>
              <Typography variant="h6">{r.label}</Typography>
              <Button startIcon={<DownloadIcon />} variant="contained" sx={{ mt: 2 }}
                onClick={() => download(`/api/reports/${r.key}.pdf`, `${r.key}.pdf`)}>Download PDF</Button>
            </CardContent></Card>
          </Grid>
        ))}
        <Grid item xs={12} sm={6} md={4}>
          <Card><CardContent>
            <Typography variant="h6">Monthly Billing Statement</Typography>
            <Stack direction="row" spacing={1} mt={2}>
              <TextField select label="Year" value={y} onChange={(e) => setY(+e.target.value)} size="small">
                {[now.getFullYear() - 1, now.getFullYear()].map(yy => <MenuItem key={yy} value={yy}>{yy}</MenuItem>)}
              </TextField>
              <TextField select label="Month" value={m} onChange={(e) => setM(+e.target.value)} size="small" sx={{ minWidth: 120 }}>
                {Array.from({ length: 12 }, (_, i) => i + 1).map(mm => <MenuItem key={mm} value={mm}>{mm}</MenuItem>)}
              </TextField>
            </Stack>
            <Button startIcon={<DownloadIcon />} variant="contained" sx={{ mt: 2 }}
              onClick={() => download(`/api/reports/monthly-billing.pdf?year=${y}&month=${m}`, `billing-${y}-${String(m).padStart(2,'0')}.pdf`)}>Download PDF</Button>
          </CardContent></Card>
        </Grid>
      </Grid>
    </Box>
  );
}
